"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelector = void 0;
const outside_click_hooks_1 = require("@shared-modules/utils/hooks/outside-click.hooks");
const React = __importStar(require("react"));
const react_collapse_1 = require("react-collapse");
const en_svg_1 = __importDefault(require("@assets/flags/en.svg"));
const es_svg_1 = __importDefault(require("@assets/flags/es.svg"));
const pt_svg_1 = __importDefault(require("@assets/flags/pt.svg"));
const ru_svg_1 = __importDefault(require("@assets/flags/ru.svg"));
require("./styles.scss");
const local_store_service_1 = require("@app/services/local-store.service");
const hooks_1 = require("@app/store/hooks");
const application_state_reducer_1 = require("@app/store/reducers/application-state.reducer");
const languages = [
    {
        label: "en",
        icon: en_svg_1.default,
    },
    {
        label: "es",
        icon: es_svg_1.default,
    },
    {
        label: "pt",
        icon: pt_svg_1.default,
    },
    {
        label: "ru",
        icon: ru_svg_1.default,
    },
];
const LanguageSelector = (props) => {
    const [isVisible, setVisibility] = React.useState(false);
    const closeHandler = React.useCallback(() => setVisibility(false), []);
    (0, outside_click_hooks_1.useOutsideClick)(() => document.querySelector(".c-language-selector"), closeHandler, [closeHandler]);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const selectedLanguage = new local_store_service_1.LocalStoreService().getSelectedLanguageOrDefault();
    const selectedLanguageIcon = languages.find(({ label }) => selectedLanguage === label);
    const selectLanguage = (language) => () => {
        new local_store_service_1.LocalStoreService().setSelectedLanguage(language);
        dispatch((0, application_state_reducer_1.setLanguage)(language));
        closeHandler();
    };
    return (React.createElement("div", { className: "c-language-selector" },
        React.createElement("div", { onClick: () => setVisibility(!isVisible), className: "c-language-selector__selected-language" },
            React.createElement("span", null, selectedLanguageIcon === null || selectedLanguageIcon === void 0 ? void 0 : selectedLanguageIcon.label),
            React.createElement("img", { src: selectedLanguageIcon === null || selectedLanguageIcon === void 0 ? void 0 : selectedLanguageIcon.icon })),
        React.createElement("div", { className: "c-language-selector__menu" },
            React.createElement("div", { className: "c-language-selector__menu-container" },
                React.createElement(react_collapse_1.UnmountClosed, { isOpened: isVisible },
                    React.createElement("div", { className: "c-language-selector__languages" }, languages.map(({ icon, label }) => {
                        return (React.createElement("div", { onClick: selectLanguage(label), key: label, className: "c-language-selector__language" },
                            React.createElement("span", null, label),
                            React.createElement("img", { src: icon })));
                    })))))));
};
exports.LanguageSelector = LanguageSelector;
